import { Injectable } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { EquipamentoTelemetria } from 'app/interfaces/Equipamento';
import { ResumoTempoOperacional } from 'app/interfaces/TemposOperacionais';
import { SegundosParaHorasPipe } from 'app/pipes/segundos-para-horas/segundos-para-horas.pipe';

@Injectable({ providedIn: 'root' })

export class EquipamentoPopupBuilder {
  private segundosParaHoras = new SegundosParaHorasPipe();

  constructor(private transloco: TranslocoService) {}

  private t(key: string, params?: Record<string, any>): string {
    return this.transloco.translate(key, params);
  }

  private calcularProporcao(valor: number, temposOperacionais: ResumoTempoOperacional[]): number {
    const total = temposOperacionais.reduce((acc, tempo) => acc + tempo.valor, 0);

    if (!total) return 0;
    return (valor / total) * 100;
  }

  build(equipamento: EquipamentoTelemetria, temposOperacionais: ResumoTempoOperacional[]): HTMLElement {

    const tempos = (temposOperacionais ?? [])
      .map(tempo => `
        <div class="tempo" style="width:${this.calcularProporcao(tempo.valor, temposOperacionais)}%; min-width:35px; background:${tempo.cor};">
          ${this.segundosParaHoras.transform(tempo.valor)}
        </div>
      `)
      .join('');

    const temposLegenda = (temposOperacionais ?? [])
      .map(tempo => `
        <div class="legenda-item">
          <span style="background-color:${tempo.cor}"></span>
          ${tempo.label}
        </div>
      `)
      .join('');

    const noData = this.t('COMPONENTS.MAPA.EQUIPMENT.no_data');
    const noConnection = this.t('COMPONENTS.MAPA.EQUIPMENT.no_connection');

    const estadoConexaoValor = equipamento?.estado_conexao ?? noData;

    const estadoBaixoSinal =
      !estadoConexaoValor ||
      estadoConexaoValor === noData ||
      estadoConexaoValor === 'sem_sinal' ||
      String(estadoConexaoValor).toLowerCase().includes('sem');

    const wifiBrokenSvg = `
      <img 
        src="/assets/equipamentos/sem-conexao-dialog.svg" 
        alt="${noConnection}" 
        style="width:20px;height:20px;">
    `;

    const estadoConexaoHtml = estadoBaixoSinal
      ? `
        <div style="display:flex;align-items:center;gap:8px;color:#D32F2F;">
          ${wifiBrokenSvg}
          <span>${noConnection}</span>
        </div>
      `
      : String(estadoConexaoValor);

    const html = `
      <div class="conteudo-informacoes">

        <div class="row p-0 m-0 cabecalho-informacoes">
          <div class="col-md-8 p-0" style="display:flex;flex-direction:column;justify-content:center;">
            
            <div class="d-flex gap-3 mt-1">
              <p>${this.t('COMPONENTS.MAPA.EQUIPMENT.fleet_label')}</p>
              <div class="status-dot ${equipamento?.estado_operacao ?? ''}"></div>
            </div>

            <h3>${equipamento?.vc_frota ?? '-'}</h3>

            <h4>
              ${equipamento?.en_tipo ?? ''}
              ${equipamento?.operador_atual ? ' - ' + equipamento.operador_atual : ''}
            </h4>
          </div>

          <div class="col-md-4 p-0 text-end">
            <img src="/assets/mapa/plantadora-informacoes.svg" style="width:140px" />
          </div>
        </div>
        <hr/>

        <div class="row p-0 m-0">
          <div class="col-md-10 p-0 table-informacoes">
            <p class="small mb-1">
              ${this.t('COMPONENTS.MAPA.EQUIPMENT.last_message_title')}
            </p>

            <table class="table table-borderless table-sm mb-1 small">

              <tr>
                <td class="py-1">
                  ${this.t('COMPONENTS.MAPA.EQUIPMENT.speed')}:
                </td>
                <td class="py-1">
                  ${equipamento?.velocidade ?? '-'} 
                  ${this.t('COMPONENTS.MAPA.EQUIPMENT.km_h')}
                </td>
              </tr>

              <tr>
                <td class="py-1">
                  ${this.t('COMPONENTS.MAPA.EQUIPMENT.fuel_level')}:
                </td>
                <td class="py-1">
                  ${equipamento?.nivel_combustivel ?? '-'}
                </td>
              </tr>

              <tr>
                <td class="py-1">
                  ${this.t('COMPONENTS.MAPA.EQUIPMENT.rpm')}:
                </td>
                <td class="py-1">
                  ${equipamento?.rpm ?? '-'} 
                  ${this.t('COMPONENTS.MAPA.EQUIPMENT.rpm')}
                </td>
              </tr>

              <tr>
                <td class="py-1"> ${this.t('COMPONENTS.MAPA.EQUIPMENT.connection_status')}: </td>
                <td class="py-1"> ${estadoConexaoHtml} </td>
              </tr>
            </table>
          </div>

          <div class="col-md-2 p-0 mt-1">

            <button class="btn btn-equipamento-informacaoes" id="abrirDialogApontamento">
              ${this.t('COMPONENTS.MAPA.EQUIPMENT.stop_button')}
            </button>

            <button class="btn btn-equipamento-informacaoes">
              ${this.t('COMPONENTS.MAPA.EQUIPMENT.go_to_chat')}
            </button>
          </div>
        </div>

        <div class="tempos-operacionais mt-2">
          <h4> ${this.t('COMPONENTS.MAPA.EQUIPMENT.operational_times')} </h4>
          <div class="barra-tempos"> ${tempos} </div>
          <div class="legenda"> ${temposLegenda} </div>
        </div>
      </div>
    `;

    const container = document.createElement('div');
    container.innerHTML = html;

    return container;
  }
}